import { render } from "./RoutePointsPage.vue?vue&type=template&id=3b3e60fa"
import script from "./RoutePointsPage.vue?vue&type=script&lang=js"
export * from "./RoutePointsPage.vue?vue&type=script&lang=js"

import "./RoutePointsPage.vue?vue&type=style&index=0&id=3b3e60fa&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__